import React from "react";
import { Box, Button, Flex, Text, VStack, useRadio } from "@chakra-ui/react";

const RadioCard = (props) => {
  const { getInputProps, getCheckboxProps } = useRadio(props);
  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box as="label" w="100%" cursor="pointer" margin="0 !important">
      <input {...input} />
      <Box
        {...checkbox}
        p={6}
        borderBottom={props.isLastChild ? "none" : "1px solid #E2E8F0"}
        _hover={{
          bg: "#e1f3ff",
          color: "#fff",
        }}
        _checked={{
          bg: "#e1f3ff",
          color: "white",
          borderColor: "#e1f3ff",
        }}
        _focus={{
          boxShadow: "outline",
        }}
      >
        <Text
          style={{
            fontWeight: "600",
            color: "rgb(66, 71, 112)",
          }}
        >
          {props.children}
        </Text>
      </Box>
    </Box>
  );
};

export const SelectableList = ({
  items = [],
  onAdd,
  isAdding,
  showNewOrgForm,
}) => {
  return (
    <Flex
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "10px 0 0",
        position: "relative",
      }}
      _after={
        isAdding
          ? {
              content: '"Adding..."',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontsize: "18px",
              fontWeight: "600",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
              zIndex: 1,
            }
          : {}
      }
      borderWidth="1px"
      borderRadius="md"
    >
      <VStack align="stretch" width="100%">
        {React.Children.toArray(
          items.map((item, index) => (
            <RadioCard
              key={item.id}
              value={item.id}
              onChange={() => onAdd(item.id)}
              isLastChild={items.length - 1 === index}
            >
              {item.name}
              <Text
                style={{
                  fontWeight: "normal",
                  color: "rgb(117 119 122)",
                  padding: "10x 0 0",
                }}
              >
                {item.city} {item.state}
              </Text>
            </RadioCard>
          ))
        )}
      </VStack>
      <Flex
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
        boxShadow="0px -4px 2px 0 rgb(0 0 0 / 9%)"
        paddingTop={6}
        paddingBottom={6}
        paddingLeft="10px"
        paddingRight="10px"
      >
        <Text style={{ padding: "10px 0" }}>My school isn't listed</Text>
        <Button
          variant="ghost"
          colorScheme="brand"
          padding="0 10px 0 10px"
          onClick={() => showNewOrgForm(true)}
        >
          Add my school or organization
        </Button>
      </Flex>
    </Flex>
  );
};
